document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.js-menu-toggle');
    const drawer = document.getElementById('drawerMenu');
    const close = document.getElementById('menuClose');
    const header = document.querySelector('.custom-header');

    const openMenu = () => {
        drawer.classList.add('open');
        header.classList.add('menu-is-open');
        document.body.style.overflow = 'hidden';
    };

    const closeMenu = () => {
        drawer.classList.remove('open');
        header.classList.remove('menu-is-open');
        document.body.style.overflow = '';
    };

    toggles.forEach(btn => {
        btn.addEventListener('click', () => {
        if (header.classList.contains('menu-is-open')) {
            closeMenu();
        } else {
            openMenu();
        }
        });
    });

    close?.addEventListener('click', () => {
        closeMenu();
    });

    drawer.addEventListener('click', (e) => {
        if (e.target === drawer) {
        closeMenu();
        }
    });

    window.addEventListener('scroll', () => {
        header.classList.toggle('scrolled', window.scrollY > 60);
    });

    const customCartTriggers = document.querySelectorAll('.js-cart-trigger');
    const originalCartButton = document.querySelector('#cart-icon-bubble');

    customCartTriggers.forEach(btn => {
        btn.addEventListener('click', e => {
        e.preventDefault();

        if (originalCartButton) {
            originalCartButton.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
            }));
        } else {
            window.location.href = '/cart';
        }
        });
    });
});